<template>
  <router-view />
</template>

<script>
export default {
  name: "TestPackageSingle"
};
</script>
